class SearchCalendar

  noneClass   : 'is-none'
  disableClass: 'is-disabled'
  depClass    : 'is-dep'
  arvClass    : 'is-arv'
  weekDayClass: ['is--hol','is--mon','is--tue','is--wed','is--thu','is--fri','is--sat']

  constructor: (@$elm, @$dateTime) ->
    @$calendarBox = $ '.js-date-calendar-box'
    @$item        = @$calendarBox.find '.js-calendar-inner'
    @$template    = @$calendarBox.find '.js-template-calendar'
    @calendarArr  = []
    @$modal       = $ '[data-remodal-id=remodal-calender]'
    @modal        = @$modal.remodal()
    @selectFLG    = false
    @$elm.on 'click', @open

  open: (event) =>
    @selectElm = event.currentTarget
    @modal.open()

  close: =>
    @modal.close()
    if window.searchStory.length < 1
      window.searchStory.push true
      setTimeout =>
        @$dateTime.first().trigger 'click'
      , 400

  init: =>
    @$elm.val @dateDay window.baseTime

    monthCount = 0
    while monthCount < 12
      @createCalendar monthCount
      monthCount++

    @calendarArr = 'data': @calendarArr
    template = _.template @$template.html()
    @$item.html template @calendarArr
    @$dayCell = @$item.find 'td'
    $firstCell = @$dayCell.not '.is-none'
    $firstCell[0].classList.add @depClass, @arvClass
    @$dayCell.on 'click', @cellClick

  cellClick: (event) =>
    elm = event.currentTarget
    $elm = $ elm
    date = $elm.data 'date'
    index = @$dayCell.index elm
    dateText = date.replace /\//g, '-'
    dateObg = date.split '/'
    $prev = @$dayCell.filter (i, _elm) ->
      return true unless index < i + 1
    return true if elm.classList.contains @noneClass
    return true if elm.classList.contains @disableClass
    if @selectFLG
      @endDay = date
      @selectFLG = false
      elm.classList.add @arvClass
      $prev.removeClass @disableClass
      @$elm[1].value = dateText
      window.endTime.setDate 1
      window.endTime.setFullYear dateObg[0]
      window.endTime.setMonth dateObg[1] - 1
      window.endTime.setDate dateObg[2]
      @usePeriod()
      @close()
    else
      @startDay = date
      @selectFLG = true
      @$dayCell.removeClass @depClass
      elm.classList.add @depClass
      $prev.addClass @disableClass
      @$dayCell.removeClass @arvClass
      @$dayCell.removeClass 'is-selected'
      @$elm[0].value = dateText
      window.startTime.setDate 1
      window.startTime.setFullYear dateObg[0]
      window.startTime.setMonth dateObg[1] - 1
      window.startTime.setDate dateObg[2]

  usePeriod: (@$endSelector) ->
    start = new Date @startDay
    end   = new Date @endDay
    start = start.getTime()
    end   = end.getTime()
    _.forEach @$dayCell, (elm) ->
      $elm = $ elm
      date = $elm.data 'date'
      return true unless date
      time = new Date date
      time = time.getTime()
      if start <= time and time <= end
        elm.classList.add 'is-selected'
      return false if time > end

  dateDay: (date) ->
    YY = date.getFullYear()
    MM = date.getMonth() + 1
    DD = date.getDate()
    MM = if MM < 10 then "0#{MM}" else MM
    DD = if DD < 10 then "0#{DD}" else DD
    "#{YY}-#{MM}-#{DD}"

  createCalendar: (count) =>
    { weekDayClass } = @
    year  = window.baseTime.getFullYear()
    month = window.baseTime.getMonth()
    day   = window.baseTime.getDate()
    baseDate   = new Date year, month, day
    baseTime   = baseDate.getTime()
    startDate  = new Date year, month + count, 1
    endDate    = new Date year, month + count + 1 , 0
    startYear  = startDate.getFullYear()
    startMonth = startDate.getMonth()
    startDay   = startDate.getDay()
    dayCount   = 1
    endDay     = endDate.getDate()
    skip       = true
    monthArr   =
      year : startYear
      month: startMonth + 1
      day  : []
    row = 0
    while row < 6
      weekArr = []
      col = 0
      while col < 7
        if row is 0 and startDay is col
          skip = false
        if dayCount > endDay
          skip = true
        date = if skip then false else dayCount++
        dateFull = if date then "#{startYear}/#{startMonth + 1}/#{date}" else false
        break if row > 0 and col is 0 and date is false
        days  = new Date startYear, startMonth, date
        _time = days.getTime()
        weekArr.push
          date   : dateFull
          dateDay: date
          weekDay: weekDayClass[days.getDay()]
          old    : _time < baseTime
        col++
      if weekArr.length > 0
        monthArr.day.push weekArr
      row++
    @calendarArr.push monthArr

  debugDate: (date) ->
    year  = date.getFullYear()
    month = date.getMonth() + 1
    day   = date.getDate()
    "#{year}/#{month}/#{day}"

export default SearchCalendar



// WEBPACK FOOTER //
// ./webpack/imports/view/search-calendar.coffee